import { Col, Container, Icon, Row } from "design-react-kit";
import React from "react";
import useWindowSize from "../../hooks/useWindowSize";
import logo from "../../logo.svg";
interface CustomFooterProps {}

const CustomFooter: React.FC<CustomFooterProps> = () => {
  const [width, height] = useWindowSize();
  return (
    <footer className="it-footer">
      <div className="it-footer-main">
        <Container>
          <section>
            <div
              style={{
                display: "flex",
                flexDirection: width > 995 ? "row" : "column",
              }}>
              <Col xs={width > 995 ? 9 : 12}>
                <div className="it-brand-wrapper">
                  <p className="">Progetto a cura di</p>
                  <a className="" href="#">
                    <Icon icon={logo} />
                    <div className="it-brand-text" style={{ width: "13rem" }}>
                      <h2>Dipartimento della Funzione Pubblica</h2>
                    </div>
                  </a>
                </div>
              </Col>
              
              
            </div>
          </section>
          <section>
            <Row></Row>
          </section>
        </Container>
      </div>
      <div className="it-footer-small-prints clearfix">
        <Container>
          <h3 className="sr-only">Sezione Link Utili</h3>
          <ul
            className="list-inline mb-0 pt-4 pb-4 d-flex"
            style={{ justifyContent: width > 425 ? "flex-start" : "center" }}>
          

            <li className="list-inline-item pl-3">
              <a target={"_blank"} href="/privacypolicy" title="Privacy-Cookies">
                Privacy policy
              </a>
            </li>
          </ul>
        </Container>
      </div>
    </footer>
  );
};

export default CustomFooter;
